<template>
  <a-row class="title">子商品设置：</a-row>
  <ChildrenTable v-model:sub-good-list="childItemList" v-model:data-list="itemList" :getContainer="getContainer" @del-subgoods="delSubgoods" />
  <a-row class="title">属性列表：</a-row>
  <AttributeTable
    v-model:attributeList="attributeList"
    v-model:attributeId="attributeId"
    v-model:mainAttrId="main_attr_id"
    :isEdit="isEdit"
    :can_add_item="can_add_item"
    :getContainer="getContainer"
    @update="handleAttrItemList"
    @del="delAttrItem"
  />
  <div v-if="attributeList.length > 0" class="multi-setting">
    <div class="multi-setting-main">
      <div class="multi-setting-row">
        <div class="multi-setting-row-title">筛选项：</div>
        <a-select
          v-for="(item, i) in attributeList"
          :key="item.id"
          class="multi-input"
          size="small"
          :dropdownMatchSelectWidth="false"
          :placeholder="item.name"
          v-model:value="multiSetting['attr' + i]"
        >
          <a-select-option key="0" :value="0">全部</a-select-option>
          <a-select-option v-for="value in item.value" :key="value.id" :value="value.id">{{ value.name }}</a-select-option>
        </a-select>
      </div>
      <div class="multi-setting-row">
        <div class="multi-setting-row-title">填充内容：</div>
        <ehf-image-upload v-model="multiSetting.pic" size="mini" style="margin-right: 3px" :getContainer="getContainer" :compressRate="imgCompressRate" />
        <a-input
          class="multi-input"
          :value="multiSetting.total_price"
          suffix="元"
          placeholder="市场价"
          size="small"
          @change="(e) => onNumChange(e, multiSetting, 'total_price', 'Float')"
        />
        <a-input
          class="multi-input"
          :value="multiSetting.integral"
          suffix="分"
          placeholder="积分"
          size="small"
          @change="(e) => onNumChange(e, multiSetting, 'integral', 'Int')"
        />
        <a-input
          class="multi-input"
          :value="multiSetting.price"
          suffix="元"
          placeholder="现金"
          size="small"
          @change="(e) => onNumChange(e, multiSetting, 'price', 'Float')"
        />
        <template v-if="isthird">
          <a-tooltip placement="topLeft" :getPopupContainer="getPopupContainer">
            <template #title>
              {{ multiSetting.linkman }}
            </template>
            <a-input class="multi-input" v-model:value="multiSetting.linkman" placeholder="联系人" size="small" />
          </a-tooltip>
          <a-tooltip placement="topLeft" :getPopupContainer="getPopupContainer">
            <template #title>
              {{ multiSetting.phone_num }}
            </template>
            <a-input class="multi-input" v-model:value="multiSetting.phone_num" placeholder="电话" size="small" />
          </a-tooltip>
          <a-tooltip placement="topLeft" :getPopupContainer="getPopupContainer">
            <template #title>
              {{ multiSetting.address }}
            </template>
            <a-input class="multi-input" v-model:value="multiSetting.address" placeholder="退货地址" size="small" />
          </a-tooltip>
        </template>
        <a-button type="link" class="btn-link-success" @click="resetMultiSetting">重置</a-button>
        <a-button type="primary" size="small" style="margin-left: 10px" title="将对筛选结果进行批量设置" @click="quickInsert">批量设置</a-button>
      </div>
      <div class="multi-setting-row" style="justify-content: space-between">
        <div>
          <a-button type="primary" size="small" title="仅子商品名称与规格名称相同时有效" @click="autoInsertSubgoods">自动填入子商品组合</a-button>
          <a-button type="primary" size="small" @click="checkSubgoods">检查子商品组合</a-button>
          <a-button
            v-if="checkSubgoodErrorList.length > 1"
            type="link"
            size="small"
            class="btn-link-success"
            style="margin-left: 10px"
            @click="showNextErrorRow()"
          >
            下一个未匹配
          </a-button>
        </div>
        <div>
          <a-checkbox v-model:checked="moreInfo" v-if="isthird">更多信息</a-checkbox>
          <a-checkbox v-model:checked="showHidden">显示隐藏</a-checkbox>
        </div>
      </div>
    </div>
  </div>
  <a-row class="title" v-if="attributeList.length === 0 && isthird" justify="end">
    <a-checkbox v-model:checked="moreInfo">更多信息</a-checkbox>
  </a-row>
  <a-table
    class="sku-table sku-table-css"
    :data-source="filterItemList"
    size="small"
    bordered
    rowKey="subid"
    :pagination="needPagination(filterItemList, 10)"
    :scroll="{ x: true }"
    :locale="{ emptyText: '请添加属性' }"
    :customRow="
      (record) => {
        return {
          onClick: () => {
            handleHighlightRow(record)
          },
        }
      }
    "
    :rowClassName="handleSkuRowClass"
    @change="(pagination) => tableChange(pagination)"
  >
    <a-table-column v-for="item in attributeList" :key="item.id" :data-index="item.id" :title="item.name" fixed="left" width="100px">
      <template #default="{ record }">
        <div class="table-ellipsis" style="width: 100px" :title="record[item.id]">{{ record[item.id] }}</div>
      </template>
    </a-table-column>
    <a-table-column key="img" title="规格图" width="67px" align="center">
      <template #default="{ record }">
        <div class="error-box" v-if="errorProps === 'pic'"></div>
        <ehf-image-upload v-model="record.pic" size="mini" style="margin: 0%" :getContainer="getContainer" :compressRate="imgCompressRate" />
      </template>
    </a-table-column>
    <a-table-column key="group" title="子商品组合">
      <template #default="{ record }">
        <div class="error-box" v-if="errorProps === 'group'"></div>
        <div class="subgoods-relation" :title="handleSubgoodsShow(record, '\r\n')" @click="changeSubgoodsRelation(record)">
          <div class="table-ellipsis relation-content" :style="{ color: isNull(record.subgoods_relation) ? '#999' : '#101010' }">
            {{ handleSubgoodsShow(record, '，') }}
          </div>
          <div class="edit-btn" title="编辑">
            <ehf-icon icon="edit-box-line"></ehf-icon>
          </div>
        </div>
      </template>
    </a-table-column>
    <a-table-column key="name" title="规格名字" width="110px">
      <template #default="{ record }">
        <div class="error-box" v-if="errorProps === 'name'"></div>
        <el-input type="textarea" style="width: 110px" v-model="record.name" :autosize="{ minRows: 1 }" placeholder="请输入" />
      </template>
    </a-table-column>
    <template v-for="item in columns">
      <a-table-column
        :key="item.key"
        v-if="!item.hidden && ((item.more_info && moreInfo) || !item.more_info)"
        :width="item.type === 'Image' ? 105 : item.width"
      >
        <template #title>
          <div class="sku-table__title">
            <span>{{ item.title }}</span>
            <a-tooltip overlayClassName="tooltip-box" v-if="showTips(item)">
              <template #title>
                <span v-html="item.tips"></span>
              </template>
              <ehf-icon icon="question-line" style="margin-left: 3px; color: #999999; cursor: pointer"></ehf-icon>
            </a-tooltip>
          </div>
        </template>
        <template #default="{ record }">
          <div class="error-box" v-if="errorProps === item.key"></div>
          <div style="white-space: nowrap">
            <a-checkbox
              v-if="item.checked"
              v-model:checked="record[item.key + '_checked']"
              :disabled="isDisabled(item, record, true)"
              @change="changeCheck(item.key + '_checked', record, item.key)"
            />
            <el-input
              type="textarea"
              v-if="item.type === 'String'"
              :autosize="{ minRows: 1 }"
              v-model="record[item.key]"
              :disabled="isDisabled(item, record)"
              placeholder="请输入"
            />
            <el-input
              v-if="item.type === 'Number'"
              class="number_input"
              :modelValue="record[item.key]"
              :disabled="isDisabled(item, record)"
              placeholder="请输入"
              @input="(value) => onNumChange({ target: { value } }, record, item.key, item.numberType)"
              :style="{ width: item.width ? item.width + 'px' : '100%', 'padding-left': item.checked ? '5px' : '0' }"
            />
            <ehf-image-upload
              v-if="item.type === 'Image'"
              v-model="record[item.key]"
              size="small"
              :disabled="isDisabled(item, record)"
              :getContainer="getContainer"
              :compressRate="imgCompressRate"
            />
          </div>
        </template>
      </a-table-column>
    </template>
    <a-table-column key="action" title="操作" width="120px">
      <template v-slot="{ record }">
        <div style="white-space: nowrap">
          <a-checkbox
            :checked="record.ischeck == 1"
            :disabled="record.is_hide == 1"
            style="margin-left: 10px; white-space: nowrap"
            @change="(e) => defaultCheckChange(e, record)"
          >
            默认选中
          </a-checkbox>
          <a-switch
            v-if="record.isok == 0 || record.isAdd"
            checkedChildren="显示"
            unCheckedChildren="隐藏"
            :checked="record.is_hide == 0"
            @change="changeHidden(record)"
          ></a-switch>
        </div>
        <div class="stop-btn" v-if="stopTemplate">
          <a-checkbox v-model:checked="record.is_stop" style="margin-left: 10px; white-space: nowrap">停购模板</a-checkbox>
          <a-select v-model:value="record.stop_id" :disabled="!record.is_stop" placeholder="请选择" style="max-width: 150px">
            <a-select-option v-for="item in stopTemplateList" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>
      </template>
    </a-table-column>
  </a-table>

  <!-- 子商品组合 -->
  <a-modal v-model:open="subgoodsModal.show" :title="subgoodsModal.itemName + '-子商品组合'" centered ok-text="保存" @ok="saveSubgoodsRelation">
    <div class="subGoodsItem" v-for="(subGood, i) in subgoodsModal.subgoods_relation" :key="i">
      <a-select
        v-model:value="subGood.subgoods_id"
        :dropdownMatchSelectWidth="false"
        size="small"
        placeholder="请选择子商品"
        showSearch
        optionFilterProp="label"
      >
        <a-select-option v-for="item in childItemList" :key="item.id" :value="item.value" :label="item.name">{{ item.name }}</a-select-option>
      </a-select>
      <el-input :modelValue="subGood.nums" size="small" placeholder="数量" @input="(value) => changeSubgoodNums({ target: { value } }, subGood)">
        <template #suffix>{{ handleUnit(subGood.subgoods_id) }}</template>
      </el-input>
      <ehf-icon class="remove-btn" icon="delete-bin-5-line" @click="removeSubGoodRelation(subgoodsModal.subgoods_relation, i)"></ehf-icon>
    </div>
    <a-button type="primary" size="small" block @click="addSubGoodRelation(subgoodsModal.subgoods_relation)">添加子商品</a-button>
  </a-modal>
</template>

<script>
  export default {
    name: 'EhfSkuTable',
  }
</script>

<script setup>
  import { getStopTemplateList as getStopTemplateListApi } from '@/api/project/shop'
  import { message } from 'ant-design-vue'
  import { isNull, deepClone, hasAuthority } from '@/utils'
  import { nanoid } from 'nanoid'
  import { ref, reactive, toRefs, onMounted, computed, watch, nextTick } from 'vue'
  import ChildrenTable from './components/ChildrenTable.vue'
  import AttributeTable from './components/AttributeTable.vue'

  const props = defineProps({
    getContainer: {
      type: Function,
      default: () => {
        return document.body
      },
    },
    columns: {
      type: Array,
      default() {
        return []
      },
    },
    dataList: {
      type: Array,
      default() {
        return []
      },
    },
    subGoodList: {
      type: Array,
      default() {
        return []
      },
    },
    stopTemplate: {
      type: Boolean,
      default() {
        return false
      },
    },
    imgCompressRate: {
      type: Number,
      default: 0,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    attributeObj: {
      type: Object,
      default() {
        return {
          attributeId: 1,
          main_attr_id: 0,
          attributeList: [],
          can_del_item: 1,
          can_add_item: 1,
        }
      },
    },
    isthird: {
      type: Boolean,
      default: false,
    },
  })
  const emit = defineEmits(['update:data-list', 'update:sub-good-list', 'update:attribute-obj', 'del_size_id_str', 'del_subgoods_id_str'])
  const { dataList, subGoodList, stopTemplate, attributeObj, getContainer } = toRefs(props)

  const stopTemplateList = ref([]) // 停购模板列表
  const itemList = ref(props.dataList) // 规格列表
  const childItemList = ref(props.subGoodList) // 子商品列表
  const attributeList = ref(props.attributeObj.attributeList) // 属性列表
  const can_del_item = ref(props.attributeObj.can_del_item) // 能否删除
  const can_add_item = ref(props.attributeObj.can_add_item) // 能否添加
  const main_attr_id = ref(props.attributeObj.main_attr_id) // 主要属性id
  const attributeId = ref(props.attributeObj.attributeId) // 递增属性id
  const multiSetting = reactive({
    // 批量设置
    attr0: 0, // 第一个属性
    attr1: 0, // 第二个属性
    attr2: 0, // 第三个属性
    pic: '', // 图片
    total_price: '', // 市场价
    integral: '', // 积分
    price: '', // 现金
    // 第三方需要
    linkman: '', // 联系人
    phone_num: '', // 联系电话
    address: '', // 联系地址
  })
  const moreInfo = ref(true) // 规格是否更多列信息
  const showHidden = ref(false) // 是否显示隐藏数据
  const subgoodsModal = reactive({
    // 子商品组合设置弹窗
    show: false,
    itemName: '',
    subid: '',
    subgoods_relation: [],
  })
  const page = ref(1) // 规格表格页码
  const errorRowId = ref('') // 规格错误行id
  const errorProps = ref('') // 错误内容key
  const showErrorIndex = ref(-1) // 显示错误样式行
  const checkSubgoodErrorList = ref([]) // 子商品组合未匹配列表

  const getPopupContainer = ref(() => document.body) // 下拉框或弹出框使用
  message.config({
    getContainer: getContainer.value,
  })
  watch(getContainer, (val) => {
    message.config({
      getContainer: val,
    })
  })

  // 属性相关内容，用于监听
  const attributeInfo = computed(() => {
    return {
      attributeId: attributeId.value,
      attributeList: attributeList.value,
      main_attr_id: main_attr_id.value,
      can_del_item: can_del_item.value,
      can_add_item: can_add_item.value,
    }
  })
  const skuTableScrollEl = computed(() => {
    return document.querySelector('.sku-table .ant-table-body')
  })
  const filterItemList = computed(() => {
    let ids = []
    attributeList.value.forEach((item, i) => {
      if (multiSetting['attr' + i] === 0) {
        ids.push('([0-9]*)')
      } else {
        ids.push(multiSetting['attr' + i])
      }
    })
    ids = '^' + ids.join() + '$'
    return itemList.value
      .filter((item) => {
        const reg = new RegExp(ids, 'g')
        return reg.test(item.attrIds)
      })
      .filter((item) => {
        return showHidden.value || (!showHidden.value && item.is_hide != 1)
      })
  })
  watch(itemList, (val) => emit('update:data-list', val))
  watch(dataList, (val) => (itemList.value = val))
  watch(childItemList, (val) => emit('update:sub-good-list', val))
  watch(subGoodList, (val) => (childItemList.value = val))
  watch(stopTemplate, (val) => {
    if (val && stopTemplateList.value.length === 0 && !hasAuthority(['29'])) {
      getStopTemplateList()
    }
  })
  watch(attributeInfo, (val) => emit('update:attribute-obj', val))
  watch(
    attributeObj,
    (val) => {
      attributeId.value = val.attributeId
      attributeList.value = val.attributeList
      main_attr_id.value = val.main_attr_id
      can_del_item.value = val.can_del_item
      can_add_item.value = val.can_add_item
    },
    { deep: true }
  )
  watch(moreInfo, (val) => localStorage.setItem('integral_form_more_info', val ? '1' : '0'))

  onMounted(() => {
    moreInfo.value = localStorage.integral_form_more_info == undefined || localStorage.integral_form_more_info === '1'
    if (props.stopTemplate && !hasAuthority(['29'])) {
      getStopTemplateList()
    }
    getPopupContainer.value = () => document.querySelector('.ant-drawer-content-wrapper')
  })

  //表格行事件，高亮点击行
  const highlightId = ref('')
  const handleHighlightRow = (record) => {
    highlightId.value = record.subid
  }

  // 删除子商品
  const delSubgoods = (ids) => emit('del_subgoods_id_str', ids)
  // 获取停购模板列表
  const getStopTemplateList = () => {
    getStopTemplateListApi().then((res) => {
      if (res.code === 0) {
        stopTemplateList.value = res.data
      }
    })
  }
  // 隐藏规格
  const changeHidden = (record) => {
    const is_hide = record.is_hide == 1 ? 0 : 1
    record.is_hide = is_hide
    if (record.ischeck === 1) {
      record.ischeck = 0
      itemList.value.some((item) => {
        if (item.is_hide != 1) {
          item.ischeck = 1
          return true
        }
      })
    }
  }
  // 处理默认选中
  const defaultCheckChange = (e, item) => {
    const checked = e.target.checked
    if (checked) {
      itemList.value.forEach((v) => {
        v.ischeck = 0
      })
      item.ischeck = 1
    }
  }
  // 处理数字输入框内容
  const onNumChange = (e, item, key, type) => {
    const { value } = e.target
    let reg = /^[0-9]*(\.[0-9]*)?$/
    const floatReg = /^[0-9]*(\.[0-9]{0,2})?$/
    const intReg = /^[0-9]*$/
    if (type === 'Int') {
      reg = intReg
    }
    if (type === 'Float') {
      reg = floatReg
    }
    if ((!isNaN(value) && reg.test(value)) || value === '') {
      item[key] = value
    }
  }
  // 选中变化
  const changeCheck = (checked, item, key) => {
    if (!item[checked]) {
      // 取消选中时，清空对应输入框数据
      item[key] = ''
    }
  }
  // 是否禁用
  const isDisabled = (columnItem, record, checkbox) => {
    return columnItem.disabled || (columnItem.notAllowEdit && !record.isAdd) || (!checkbox && columnItem.checked && !record[columnItem.key + '_checked'])
  }
  // 展示提示
  const showTips = (item) => {
    return item.tips && item.tips !== ''
  }
  // 子商品数量改变
  const changeSubgoodNums = (e, item) => {
    const { value } = e.target
    const intReg = /^[0-9]*$/
    if (intReg.test(value) || value === '') {
      item.nums = value
    }
  }
  // 单位处理
  const handleUnit = (subid) => {
    const item = childItemList.value.find((v) => v.id === subid)
    if (item && item.unit !== '') {
      return item.unit
    } else {
      return '件'
    }
  }
  // 添加子商品组合
  const addSubGoodRelation = (relationList) => {
    relationList.push({
      subgoods_id: null,
      nums: '1',
    })
  }
  // 移除子商品组合
  const removeSubGoodRelation = (relationList, i) => {
    relationList.splice(i, 1)
  }
  // 删除属性
  const delAttrItem = (index) => {
    multiSetting['attr' + index] = 0
    handleAttrItemList()
  }
  /**
   * @description 处理多属性对应的规格列表
   * @param {Boolean} editValue 是否只修改了属性值。是则保留已编辑内容
   */
  const handleAttrItemList = (editValue) => {
    function getAttrItem(i, ...attrItems) {
      let list = []
      if (attributeList.value[i]) {
        attributeList.value[i].value.forEach((attrItem) => {
          list = list.concat(getAttrItem(i + 1, ...attrItems, attrItem))
        })
      } else {
        if (attrItems.length > 0) {
          const attrIds = attrItems.map((v) => v.id).join()
          let item = getNewItem()
          let autoName = true
          let names = []
          if (editValue) {
            // 如果只是修改了属性值
            const findItem = itemList.value.find((v) => v.attrIds === attrIds)
            if (findItem) {
              item = deepClone(findItem)
              autoName = false
            }
          }
          for (let index = 0; index < i; index++) {
            item[attributeList.value[index].id] = attrItems[index].name
            names.push(attrItems[index].name)
          }
          if (autoName) {
            item.name = names.join('-')
          }
          if (!item.code) {
            item.code = item.name
          }
          item.attrIds = attrIds
          list.push(item)
        }
      }
      return list
    }
    let list = getAttrItem(0)
    const delSizeIds = compareItemList(list, itemList.value).map((v) => v.subid)
    if (delSizeIds.length > 0) {
      emit('del_size_id_str', delSizeIds)
    }
    const checkItem = list.find((v) => v.ischeck === 1)
    if (list.length > 0 && !checkItem) {
      list[0].ischeck = 1
    }
    itemList.value = list
  }
  // 数组比较，输出差异内容
  const compareItemList = (list, originList) => {
    let diffList = []
    originList.forEach((origin) => {
      if (!origin.isAdd) {
        const item = list.find((v) => v.attrIds === origin.attrIds)
        if (!item || item.isAdd) {
          diffList.push(deepClone(origin))
        }
      }
    })
    return diffList
  }
  // 获取新规格对象
  const getNewItem = () => {
    const item = {
      isAdd: true,
      subid: nanoid(),
      pic: '',
      name: '',
      ischeck: 0,
      is_stop: true, // 是否停购
      stop_id: '23', // 停购模板id
      subgoods_relation: [],
      is_hide: 0,
    }
    props.columns.forEach((v) => {
      item[v.key] = ''
      if (v.checked) {
        item[v.key + '_checked'] = true
      }
    })
    return item
  }
  // 批量插入
  const quickInsert = () => {
    let ids = []
    attributeList.value.forEach((item, i) => {
      ids.push(multiSetting['attr' + i])
    })
    ids = ids.join().replaceAll('0', '([0-9]*)')
    itemList.value.forEach((item) => {
      const reg = new RegExp(ids, 'g')
      if (reg.test(item.attrIds)) {
        multiSetting.pic && (item.pic = multiSetting.pic)
        multiSetting.total_price && (item.total_price = multiSetting.total_price)
        multiSetting.integral && (item.integral = multiSetting.integral)
        if (item.price_checked) {
          multiSetting.price && (item.price = multiSetting.price)
        }
        multiSetting.linkman && (item.linkman = multiSetting.linkman)
        multiSetting.phone_num && (item.phone_num = multiSetting.phone_num)
        multiSetting.address && (item.address = multiSetting.address)
      }
    })
  }
  // 自动插入子商品组合
  const autoInsertSubgoods = () => {
    if (childItemList.value.length === 0) {
      return message.error('请添加子商品')
    }
    let hasInsert = false
    childItemList.value.forEach((subgood) => {
      const item = itemList.value.find((v) => v.name === subgood.name)
      if (item) {
        item.subgoods_relation = item.subgoods_relation || []
        const subItemIndex = item.subgoods_relation.findIndex((s) => s.subgoods_id === subgood.id)
        if (subItemIndex === -1) {
          hasInsert = true
          item.subgoods_relation.push({
            subgoods_id: subgood.id,
            nums: '1',
          })
        }
      }
    })
    if (hasInsert) {
      message.success('自动填入完成')
    } else {
      message.error('无可自动填入规格')
    }
  }
  // 检查子商品组合
  const checkSubgoods = () => {
    let errorList = []
    itemList.value.forEach((item, i) => {
      const subgoods_relation = item.subgoods_relation || []
      if (subgoods_relation.length > 0) {
        let hasSub = false
        subgoods_relation.forEach((rel) => {
          const subItem = childItemList.value.find((v) => v.id === rel.subgoods_id)
          if (subItem && subItem.name === item.name) {
            hasSub = true
          }
        })
        if (!hasSub) {
          errorList.push(i)
        }
      } else if (item.is_hide == 0) {
        errorList.push(i)
      }
    })
    checkSubgoodErrorList.value = errorList
    if (errorList.length > 0) {
      showNextErrorRow(true)
    } else {
      errorRowId.value = ''
      message.success('子商品组合已全部配对')
    }
  }
  // 显示下一个未匹配行
  const showNextErrorRow = (first) => {
    multiSetting.attr0 = 0
    multiSetting.attr1 = 0
    multiSetting.attr2 = 0
    const errorList = checkSubgoodErrorList.value
    if (first || showErrorIndex.value === errorList.length - 1) {
      showErrorIndex.value = 0
    } else {
      showErrorIndex.value += 1
    }
    const errorRow = errorList[showErrorIndex.value]
    if ((errorRow + 1) % 10 > 0) {
      page.value = parseInt((errorRow + 1) / 10) + 1
    }
    highlightId.value = itemList.value[errorRow].subid
    errorRowId.value = itemList.value[errorRow].subid
    errorProps.value = 'group'
    nextTick(() => {
      scrollErrorBox()
    })
  }
  // 重置批量设置
  const resetMultiSetting = () => {
    multiSetting.pic = ''
    multiSetting.total_price = ''
    multiSetting.integral = ''
    multiSetting.price = ''
    multiSetting.linkman = ''
    multiSetting.phone_num = ''
    multiSetting.address = ''
  }
  // 是否需要分页
  const needPagination = (list, pageSize) => {
    if (list.length > pageSize) {
      return {
        pageSize,
        current: page.value,
      }
    } else {
      return false
    }
  }
  const tableChange = (pagination) => {
    page.value = pagination.current
  }
  // 处理子商品组合内容显示
  const handleSubgoodsShow = (record, separator) => {
    if (record.subgoods_relation && record.subgoods_relation.length > 0) {
      let content = []
      record.subgoods_relation.forEach((item) => {
        if (getChildrenItemName(item.subgoods_id)) {
          content.push(getChildrenItemName(item.subgoods_id) + '(' + item.nums + handleUnit(item.subgoods_id) + ')')
        }
      })
      return content.join(separator)
    } else {
      return '暂无子商品组合'
    }
  }
  // 修改子商品组合
  const changeSubgoodsRelation = (record) => {
    subgoodsModal.subid = record.subid
    subgoodsModal.itemName = record.name || '未填写规格名称'
    subgoodsModal.subgoods_relation = deepClone(record.subgoods_relation || [])
    subgoodsModal.show = true
  }
  // 保存子商品组合
  const saveSubgoodsRelation = () => {
    let errorMsg = ''
    subgoodsModal.subgoods_relation.some((subitem) => {
      if (isNull(subitem.subgoods_id)) {
        errorMsg = '请选择子商品'
        return true
      }
      if (subitem.nums == 0) {
        errorMsg = '请填写子商品数量不可为0或空'
        return true
      }
    })
    if (errorMsg !== '') {
      message.error(errorMsg)
      return
    }
    const item = itemList.value.find((v) => v.subid === subgoodsModal.subid)
    if (item) {
      item.subgoods_relation = deepClone(subgoodsModal.subgoods_relation)
    }
    subgoodsModal.show = false
  }
  // 获取子商品名称
  const getChildrenItemName = (subgoods_id) => {
    const item = childItemList.value.find((v) => v.id === subgoods_id)
    if (item) {
      return item.name
    } else {
      return ''
    }
  }
  // 处理规格表格行样式
  const handleSkuRowClass = (record) => {
    let classList = []
    if (record.subid == highlightId.value) {
      classList.push('highlight')
    }
    if (record.subid == errorRowId.value) {
      classList.push('errorRow')
    }
    return classList.join(' ')
  }
  // 校验规格内容
  const validSkuContent = () => {
    if (childItemList.value.length === 0) {
      return {
        table: '.children-table',
        errorMsg: '请添加子商品',
      }
    }
    if (attributeList.value.length === 0) {
      return {
        table: '.attribute-table',
        errorMsg: '请添加属性',
      }
    }
    multiSetting.attr0 = 0
    multiSetting.attr1 = 0
    multiSetting.attr2 = 0
    let errorMsg = ''
    let errorRow = -1
    let columns = []
    let dataList = []
    columns = props.columns
    dataList = itemList.value
    dataList.some((v, i) => {
      if (v.is_hide != 1) {
        if (
          v.pic == '' &&
          isNull(v.subgoods_relation) &&
          v.name == '' &&
          v.total_price == '' &&
          v.integral == '' &&
          v.price == '' &&
          v.linkman == '' &&
          v.phone_num == '' &&
          v.address == '' &&
          v.purchase_price == '' &&
          v.code == ''
        ) {
          if (v.ischeck == '1') {
            errorRow = i
            errorMsg = '默认选中规格不能为空'
            return true
          }
        } else {
          let sublist = []
          if (isNull(v.pic)) {
            errorRow = i
            errorMsg = '请完善规格图片'
            errorProps.value = 'pic'
            return true
          }
          v.subgoods_relation.some((subitem) => {
            if (isNull(subitem.subgoods_id)) {
              errorMsg = '请选择子商品'
              return true
            }
            if (subitem.nums > 0) {
              sublist.push({ id: subitem.subgoods_id, nums: subitem.nums })
            } else {
              errorMsg = '请填写子商品数量不可为0或空'
              return true
            }
          })
          if (errorMsg !== '') {
            errorRow = i
            errorProps.value = 'group'
            return true
          }
          if (sublist.length === 0) {
            errorRow = i
            errorMsg = '请完善子商品组合信息'
            errorProps.value = 'group'
            return true
          }
          if (v.name === '') {
            errorRow = i
            errorMsg = '请填写规格名称'
            errorProps.value = 'name'
            return true
          }
          columns.some((column) => {
            if (column.checked) {
              if (v[column.key + '_checked'] && isNull(v[column.key])) {
                errorMsg = '请填写' + column.title
                errorProps.value = column.key
                return true
              }
            } else if (column.is_third) {
              if (props.isthird) {
                if (isNull(v[column.key])) {
                  errorMsg = '请填写' + column.title
                  errorProps.value = column.key
                  return true
                } else if (column.key === 'phone_num') {
                  const reg = /^((0\d{2,3}-\d{7,8})|(1[0-9]{10}))$/
                  if (!reg.test(v[column.key])) {
                    errorMsg = '电话格式不正确'
                    errorProps.value = column.key
                    return true
                  }
                }
              }
            } else {
              if (isNull(v[column.key]) && v[column.key] !== '0') {
                errorMsg = '请填写' + column.title
                errorProps.value = column.key
                return true
              }
            }
          })
          if (errorMsg !== '') {
            errorRow = i
            return true
          }
        }
      }
    })
    let showIsCheck = false
    dataList.forEach((item) => {
      if (item.ischeck == '1') {
        showIsCheck = true
        return
      }
    })
    if (!showIsCheck && errorMsg === '') {
      errorMsg = '请选择默认规格'
    }
    if (errorRow > -1) {
      if ((errorRow + 1) % 10 > 0) {
        page.value = parseInt((errorRow + 1) / 10) + 1
      }
      highlightId.value = dataList[errorRow].subid
      errorRowId.value = dataList[errorRow].subid
      if (['linkman', 'phone_num', 'address'].indexOf(errorProps.value) > -1) {
        moreInfo.value = true
      }
      nextTick(() => {
        scrollErrorBox()
      })
    } else {
      errorRowId.value = ''
      errorProps.value = ''
    }
    return {
      table: '.sku-table',
      errorMsg,
    }
  }
  // 高亮并定位校验失败的内容
  const scrollErrorBox = () => {
    let index = -1
    skuTableColList().forEach((el, i) => {
      if (el.getAttribute('data-key') == errorProps.value) {
        index = i
      }
    })
    let errorEl = null
    if (index > -1) {
      skuTableHeadList().forEach((item, i) => {
        if (i == index) {
          errorEl = item
        }
      })
      if (errorEl) {
        const scrollLeft = errorEl.offsetLeft
        skuTableScrollEl.value.scrollLeft = scrollLeft - 800
      }
    }
  }
  // 规格表格列dom列表
  const skuTableColList = () => {
    return document.querySelectorAll('.sku-table table colgroup col')
  }
  // 规格表格头dom列表
  const skuTableHeadList = () => {
    return document.querySelectorAll('.sku-table .ant-table-thead tr th')
  }

  defineExpose({
    validSkuContent,
  })
</script>

<style lang="scss" scoped>
  .title {
    margin-bottom: 10px;
    padding-left: 10px;
  }
  .sku-table-css {
    .sku-table__title {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .subgoods-relation {
      margin: -8px;
      min-width: 150px;
      height: 50px;
      padding: 0 8px;
      display: flex;
      align-items: center;
      cursor: pointer;
      &:hover {
        .edit-btn {
          visibility: visible;
        }
      }
      .relation-content {
        flex: 1;
      }
      .edit-btn {
        font-size: 16px;
        cursor: pointer;
        visibility: hidden;
      }
    }
    .ant-input,
    ::v-deep(.el-input__inner),
    ::v-deep(.el-textarea__inner) {
      border: none;
      &:focus {
        box-shadow: none;
      }
    }
    ::v-deep(.el-input__inner) {
      padding: 0;
    }
    .table-ellipsis {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    textarea.ant-input {
      margin-bottom: 0;
      word-break: break-all;
    }
    .btn-link-danger {
      padding: 0;
      margin-left: 10px;
    }
    .stop-btn {
      margin-top: 10px;
      display: flex;
      align-items: center;
    }

    .table-footer {
      display: flex;
    }
    .add-btn {
      flex: 1;
      padding: 8px;
      text-align: center;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      & + .add-btn {
        border-left: 1px solid #e0e0e0;
      }
    }
  }
  .subGoodsItem {
    display: flex;
    margin-bottom: 10px;
    align-items: center;
    .ant-select,
    .ant-input,
    ::v-deep(.el-input) {
      margin-right: 5px;
    }
    .ant-select {
      flex: 1;
      ::v-deep(.ant-select-selector) {
        height: auto;
        .ant-select-selection-item {
          white-space: pre-wrap;
          overflow: initial;
        }
      }
    }
    .ant-input-affix-wrapper,
    ::v-deep(.el-input) {
      width: 65px;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
      line-height: 1.5715;
      .el-input__inner {
        padding: 0px 7px;
        height: auto;
        line-height: 1.5715;
        border: none;
      }
    }
    .remove-btn {
      cursor: pointer;
      color: #999;
    }
  }
  .multi-setting {
    margin-bottom: 15px;
    .multi-setting-main {
      display: flex;
      flex-direction: column;
      .multi-setting-row {
        display: flex;
        align-items: center;
        .multi-setting-row-title {
          font-size: 14px;
        }
        & + .multi-setting-row {
          margin-top: 10px;
        }
      }
    }
    .multi-input {
      width: 100px;
      margin-right: 8px;
      ::v-deep(.ant-select-selector) {
        height: auto;
        .ant-select-selection-item {
          white-space: pre-wrap;
          overflow: initial;
          word-break: break-all;
        }
      }
    }
  }
  ::v-deep(.el-textarea__inner) {
    padding: 4px 11px;
    overflow: hidden;
  }
  ::v-deep(.el-input__suffix-inner) {
    color: rgba(0, 0, 0, 0.85);
  }
  .ant-btn-link {
    padding: 0;
    & + & {
      margin-left: 10px;
    }
  }

  .errorRow {
    .error-box {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 1px solid red;
      pointer-events: none;
    }
  }
  .error-box {
    display: none;
  }

  .sku-table {
    ::v-deep(.ant-table-body) {
      scroll-behavior: smooth;
    }
  }
</style>

<style lang="scss">
  .sku-table-css {
    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
      padding: 10px 14px;
      position: relative;
    }
    .highlight > td {
      background-color: rgb(230, 247, 255) !important;
    }
    .ant-table-footer {
      padding: 0 !important;
    }
    .ant-checkbox-group label {
      width: 180px;
      min-height: 29px;
      padding-bottom: 2px;
      border-bottom: 1px solid #eee;
    }
    .ant-checkbox-group label:last-of-type {
      padding-bottom: 2px;
      border-bottom: 1px solid #eee;
    }
    .ant-table-tbody > tr td:nth-of-type(3) .ant-input:not(:last-of-type) {
      border-bottom: 1px solid #eee;
    }
  }
</style>
